/**
 * This file centralizes all application routes to ensure consistency
 * across the codebase and facilitate easier route management.
 */

export const routes = {
  wishlists: '/account/wishlists',
};

export default routes;
